<template>
  <div class="contact-page">
    <!-- 头图：素材 contacts_bg 已含 SMART / AI智慧夹耳 等文案，不再叠 HTML 文字 -->
    <section class="contact-page__hero" aria-label="联系我们主视觉">
      <img
        class="contact-page__hero-img"
        :src="heroImgUrl"
        alt="PAXA CrysClip SMART AI智慧夹耳主视觉"
        @load="onHeroImgLoad"
      />
    </section>

    <section class="contact-page__form-section" aria-labelledby="contact-form-title">
      <h2 id="contact-form-title" class="visually-hidden">留言表单</h2>
      <form class="contact-page__form" novalidate @submit.prevent="onSubmit">
        <div class="contact-page__row">
          <label class="contact-page__label" for="contact-name">姓名</label>
          <input
            id="contact-name"
            v-model.trim="form.name"
            type="text"
            class="contact-page__input"
            name="name"
            autocomplete="name"
            placeholder="请输入名字"
          />
        </div>
        <div class="contact-page__row">
          <label class="contact-page__label" for="contact-email">邮箱</label>
          <input
            id="contact-email"
            v-model.trim="form.email"
            type="email"
            class="contact-page__input"
            name="email"
            autocomplete="email"
            placeholder="请输入邮箱"
          />
        </div>
        <div class="contact-page__row">
          <label class="contact-page__label" for="contact-phone">电话</label>
          <input
            id="contact-phone"
            v-model.trim="form.phone"
            type="tel"
            class="contact-page__input"
            name="phone"
            autocomplete="tel"
            placeholder="请输入电话"
          />
        </div>
        <div class="contact-page__row contact-page__row--top">
          <label class="contact-page__label" for="contact-content">内容</label>
          <textarea
            id="contact-content"
            v-model.trim="form.content"
            class="contact-page__textarea"
            name="content"
            rows="5"
            placeholder="请输入内容"
          />
        </div>
        <button type="submit" class="contact-page__submit">提交</button>
      </form>
    </section>
  </div>
</template>

<script>
import contactsBg from '@/assets/contacts_bg.png'

export default {
  name: 'ContactPage',
  data() {
    return {
      /** 联系我们页顶图：src/assets/contacts_bg.png（图内自带标题字，勿再覆盖） */
      heroImgUrl: contactsBg,
      /**
       * 留言表单（后续对接接口时可整包提交）
       * @type {{ name: string, email: string, phone: string, content: string }}
       */
      form: {
        /** 姓名 */
        name: '',
        /** 邮箱 */
        email: '',
        /** 电话 */
        phone: '',
        /** 留言内容 */
        content: ''
      }
    }
  },
  mounted() {
    console.info('[ContactPage] 联系我们页已挂载，头图:', this.heroImgUrl)
  },
  methods: {
    /** 记录头图固有像素与布局尺寸，便于与设计稿对齐 */
    onHeroImgLoad(ev) {
      const el = ev?.target
      if (!el || !(el instanceof HTMLImageElement)) {
        console.error('[ContactPage] 头图 load 事件目标异常')
        return
      }
      console.info('[ContactPage] 头图 natural:', el.naturalWidth, el.naturalHeight, '显示:', Math.round(el.getBoundingClientRect().width), Math.round(el.getBoundingClientRect().height))
    },
    /** 提交前校验；暂无后端，仅打日志 */
    onSubmit() {
      const { name, email, phone, content } = this.form
      if (!name) {
        console.error('[ContactPage] 提交失败: 姓名为空')
        return
      }
      if (!email) {
        console.error('[ContactPage] 提交失败: 邮箱为空')
        return
      }
      if (!phone) {
        console.error('[ContactPage] 提交失败: 电话为空')
        return
      }
      if (!content) {
        console.error('[ContactPage] 提交失败: 内容为空')
        return
      }
      console.info('[ContactPage] 表单提交（待接接口）:', {
        name,
        email,
        phone,
        contentLength: content.length
      })
    }
  }
}
</script>

<style scoped>
.contact-page {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

/* 顶贴 ActionBar；尺寸按素材 910×491 比例缩放，避免 cover/vh 裁切失真 */
.contact-page__hero {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  line-height: 0;
}

.contact-page__hero-img {
  width: 400px;
  max-width: 100%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.contact-page__form-section {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  padding: clamp(40px, 6vh, 80px) 24px clamp(72px, 10vh, 120px);
  box-sizing: border-box;
}

.contact-page__form {
  width: 100%;
}

.contact-page__row {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: clamp(12px, 2vw, 24px);
  align-items: center;
  margin-bottom: clamp(18px, 2.5vh, 24px);
}

.contact-page__row--top {
  align-items: start;
}

.contact-page__row--top .contact-page__label {
  padding-top: 10px;
}

.contact-page__label {
  font-size: 15px;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
  white-space: nowrap;
}

.contact-page__input,
.contact-page__textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 15px;
  line-height: 1.45;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
  color: #000;
  background: #fff;
}

.contact-page__input::placeholder,
.contact-page__textarea::placeholder {
  color: rgba(0, 0, 0, 0.35);
}

.contact-page__textarea {
  resize: vertical;
  min-height: 120px;
}

.contact-page__submit {
  width: 100%;
  margin-top: clamp(8px, 1.5vh, 16px);
  padding: 12px 24px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.22);
  background: #fff;
  font-size: 15px;
  color: #000;
  cursor: pointer;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.contact-page__submit:hover {
  background: rgba(0, 0, 0, 0.04);
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 560px) {
  .contact-page__row {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .contact-page__row--top .contact-page__label {
    padding-top: 0;
  }
}
</style>
